(function () {
  function getStockMap(root) {
    var el = root.querySelector('script[data-preorder-stock-map]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function getSelectedVariantId(root) {
  var sel = root.querySelector('select[name="id"]:not([disabled])');
  var input = root.querySelector('input[name="id"]:not([disabled])');
  var correctId = sel ? sel.value : (input ? input.value : null);
  if (input && correctId && input.value !== correctId) {
    input.value = correctId;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  return correctId;
}
  function applyState(root, stockMap) {
  var id = getSelectedVariantId(root);
  var info = id ? stockMap[id] : null;
  if (!info) return;

  var aStock = Number(info.pieceAStock);
  var aContinue = !!info.pieceAContinueSelling;
  var bStock = Number(info.pieceBStock);
  var bContinue = !!info.pieceBContinueSelling;

  var aOut = aStock <= 0;
  var bOut = bStock <= 0;

  var state;
  if (!aOut && !bOut) {
    state = 'atc';
  } else if (aOut && bOut) {
    state = (aContinue && bContinue) ? 'preorder' : 'soldout';
  } else if (aOut) {
    state = aContinue ? 'preorder' : 'soldout';
  } else {
    state = bContinue ? 'preorder' : 'soldout';
  }

  var isPreorder = state === 'preorder';
  var isSoldOut = state === 'soldout';

  var textEls = root.querySelectorAll('.m-add-to-cart--text');
  var submitBtns = root.querySelectorAll('product-form button[type="submit"], form button[type="submit"]');
  submitBtns.forEach(function (btn) {
    btn.classList.remove('is-preorder-bundle', 'is-soldout-bundle');
    if (isPreorder) {
      btn.disabled = false;
      btn.classList.add('is-preorder-bundle');
    } else if (isSoldOut) {
      btn.disabled = true;
      btn.classList.add('is-soldout-bundle');
    } else {
      btn.disabled = false;
    }
  });

  textEls.forEach(function (textEl) {
  if (!textEl.dataset.originalText) textEl.dataset.originalText = textEl.textContent;
  if (isPreorder) {
    textEl.textContent = (window.preorderBundleLabel || 'Pré-encomenda');
  } else if (isSoldOut) {
    textEl.textContent = (window.soldOutBundleLabel || 'Esgotado');
  } else {
    textEl.textContent = textEl.dataset.originalText;
  }
});

  var forms = root.querySelectorAll('form[data-type="add-to-cart-form"]');
  forms.forEach(function (form) {
    var propInput = form.querySelector('input[name="properties[Pré-encomenda]"]');
    if (isPreorder) {
      if (!propInput) {
        propInput = document.createElement('input');
        propInput.type = 'hidden';
        propInput.name = 'properties[Pré-encomenda]';
        form.appendChild(propInput);
      }
      propInput.value = 'Sim';
    } else if (propInput) {
      propInput.remove();
    }
  });
}
  function init(root) {
    var stockMap = getStockMap(root);
    if (!stockMap) return;
    var run = function () { applyState(root, stockMap); };
    run();
    root.addEventListener('change', function () { setTimeout(run, 50); });
    var observer = new MutationObserver(function () { setTimeout(run, 50); });
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
    root.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
      form.addEventListener('submit', function () { run(); }, true);
    });
  }
  document.querySelectorAll('product-info').forEach(function (root) {
    if (root.querySelector('script[data-preorder-stock-map]')) init(root);
  });
})();